import {Component, EventEmitter, Input, Output, ViewChild, ElementRef} from '@angular/core';
import {BUTTON_STYLES, BUTTON_TYPES} from "../buttons/buttons.component";


export enum TEXT_FIELD_VALIDATIONS {
  VALID = 'valid',
  ERROR = 'error',
  DISABLED = 'disabled'
}

export enum VALIDATION_STATE {
  None,
  Valid,
  Invalid,
  Validating
}

export enum TEXT_FIELD_TYPES {
  EMAIL = 'email',
  URL = 'url',
  TEXT = 'text',
  PASSWORD = 'password',
  NUMBER = 'number',
  TEXTAREA = 'textarea',
}

@Component({
  selector: 'beaconstac-textfield',
  templateUrl: './textfields.component.html',
  styleUrls: ['./textfields.component.scss']
})
export class TextfieldsComponent {

  @ViewChild('textInput', {static: false}) textInput: ElementRef;

  TEXT_FIELD_VALIDATIONS = TEXT_FIELD_VALIDATIONS;
  TEXT_FIELD_TYPES = TEXT_FIELD_TYPES;
  BUTTON_STYLES = BUTTON_STYLES;
  BUTTON_TYPES = BUTTON_TYPES;
  // Validation state when validationState is set to true
  VALIDATION_STATE = VALIDATION_STATE;

  /**
   * validity for text-field
   */
  @Input()
  valid: TEXT_FIELD_VALIDATIONS = TEXT_FIELD_VALIDATIONS.VALID;

  /**
   * Text-field type
   */
  @Input()
  type: TEXT_FIELD_TYPES = TEXT_FIELD_TYPES.TEXT;

  @Input()
  validationState: VALIDATION_STATE = VALIDATION_STATE.None;
  /**
   * Label above text-field
   */
  @Input()
  label: boolean;

  /**
   * Is text-field disabled
   */
  @Input()
  disabled: boolean = false;

  /**
   * Is text-field disabled but clickable
   */
  @Input()
  readonly: boolean = false;

  /**
   * Is text-field-validator disabled
   */
  @Input()
  disableValidator: boolean = false;

  /**
   * Button contents
   *
   * @required
   */
  @Input()
  text = '';

  /**
   * text change emitter
   */
  @Output()
  textChange: EventEmitter<string> = new EventEmitter();

  @Output()
  editClick: EventEmitter<void> = new EventEmitter();

  /**
   * Placeholder for text-field
   *
   * @required
   */
  @Input()
  placeholder = 'Text field';

  /**
   * Title for text-field
   *
   * @required
   */
  @Input()
  title = 'Title';

  /**
   * Is change button visible
   */
  @Input()
  changeButtonVisible: boolean = false;

  /**
   * Change button text
   */
  @Input()
  changeButtonText: string = 'change';

  /**
   * If input is required
   */
  @Input()
  required: boolean = false;

  /**
   * Custom width for text-field
   */
  @Input()
  maxWidth: string = '50%';

  /**
   * regex/pattern required for text-field
   */
  @Input()
  pattern: string = '';

  @Input()
  errorMessage: string = '';

  /**
   * Optional click handler
   */
  @Output()
  onClick = new EventEmitter<Event>();

  @Input()
  disableInput: boolean;

  @Input()
  icon: string;

  @Input()
  id: string = 'input_1';

  @Input()
  color: 'primary' | 'secondary' = 'primary';

  @Input()
  labelIcon: string = '';

  @Input()
  isInputGroup = false;

  @Output()
  labelIconClick: EventEmitter<any> = new EventEmitter();

  @Input()
  validationSupport: boolean = false;

  @Input()
  showEditIcon: boolean = true;

  @Input()
  showValidationBox: boolean = true;

  @Input()
  showEditPencil: boolean = true;

  @Input() 
  showErrorIcon: boolean = true;

  showPassword: boolean;
  emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
  isInputFocused: boolean = false;

  getLabelColorClass(){
    return this.color;
  }

  togglePasswordView() {
    this.showPassword = !this.showPassword;
  }

  emitTextChange(value) {
    this.textChange.emit(value)
  }

  toggleLabelIcon() {
    this.labelIconClick.emit();
  }

  handleEditIconClick() {
    this.textInput.nativeElement.focus();
    this.editClick.emit()
  }

}
